import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { TenantModule } from '../models/tenant/tenantModule'
import { TenantService } from './tenant.service'
import { TenantModules } from '../../../shared/enum/tenantModules'
import { CurrentTenant } from '@app/core/models/CurrentTenant'

@Injectable({
  providedIn: 'root'
})
export class TenantModulesService {

  private tenantId = new BehaviorSubject<string>(undefined);
  private tenantModules = new BehaviorSubject<TenantModule[]>([]);

  constructor(
    private tenantService: TenantService
  ) {
    this.loadTenantModules()
  }

  isEnabled(...modules: TenantModules[]): Observable<boolean[]> {
    const modulesNames = (modules || []).map((m) => m.toLowerCase())

    return this.tenantModules.pipe(map((modules) => modulesNames.map((moduleName) => {
      const module = modules.find((m) => m.name.toLowerCase() === moduleName)

      return module ? module.enabled : false
    })))
  }

  private loadTenantModules () {
    this.tenantService.getCurrentTenant()
      .subscribe((currentTenant: CurrentTenant) => {
        this.tenantId.next(currentTenant.id)
        this.tenantModules.next(currentTenant.modules || [])
      })
  }
}
